export const STORE_PAGINATION = {
  // Number of package items displayed per page
  ITEMS_PER_PAGE_MOBILE: 4,
  ITEMS_PER_PAGE_DESKTOP: 3,
} as const;
